import { __ } from "@wordpress/i18n";
import React, { useEffect, useState } from 'react';
import apiFetch from '@wordpress/api-fetch';
import Hint from '../../components/Hint/Hint';
import Switch from '../../components/Switch/Switch';
import TagInput from '../../components/TagInput/TagInput';
import InputBox from '../../components/InputBox/InputBox';
import SingleSelect from '../../components/SingleSelect/SingleSelect';
import { useMenu } from '../../contexts/MenuContext';
import InfoBox from '../../components/InfoBox/InfoBox';
import withForm from '../../layouts/withForm';

const GeneralSettings = ({handleChange}) => {
    const {
        settingData
    } = useMenu();

     const [roles, setRoles] = useState({});   
        const [rolesArray, setRolesArray] = useState([]);   
        useEffect(() => {
            const fetchRoles = async () => {
                try {
                    const results = await apiFetch({
                        path: "/ultimate-security/v1/get-roles",
                        method: 'GET'
                    });
            
                    // Save to localStorage
                    localStorage.setItem("plusRoles", JSON.stringify(results));
            
                    // Update state
                    setRoles(results);
                } catch (error) {
                    console.error("Error fetching roles:", error);
                }
            };
            
            // Check if data is already in localStorage
            const storedRoles = localStorage.getItem("plusRoles");
            if (storedRoles) {
                setRoles(JSON.parse(storedRoles));
            } else {
                fetchRoles();
            }
        }, []);
        
        useEffect(() => {
            const tempArray = Object.entries(roles).length && Object.entries(roles).map(([code, { name, count }]) => ({
                value: name, // name
                code: code, // Use the key as the code
            }));
            setRolesArray(tempArray)
        }, [roles])


    return (
        <>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Enable Passkeys", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                           <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Enable\ / Disable Passkeys", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("If enabled, users can use passkeys.", "ultimate-security")}</p>
                                </div>                            
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.passkeys.general_settings.enable_passkeys"
                                    checked={settingData?.security?.passkeys?.general_settings?.enable_passkeys}
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Enable Maximum Passkeys", "ultimate-security")}</h5> 
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                           <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Enable\ / Disable Max Passkeys", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable or disable the restriction for the maximum number of passkeys per user.", "ultimate-security")}</h6>
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("If disabled, users can register an unlimited number of passkeys.", "ultimate-security")}</p>
                                </div>                            
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.passkeys.general_settings.max_passkeys_enabled"
                                    checked={settingData?.security?.passkeys?.general_settings?.max_passkeys_enabled}
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           

            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Max Passkeys Number", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="number-group d-flex align-items-center gap-2">
                                    <Hint position="top" content={__("Set the Number Of Passkeys", "ultimate-security")}/>                                    
                                    <InputBox
                                        name="security.passkeys.general_settings.max_passkeys_number"
                                        type="number"
                                        min={1}
                                        max={5}
                                        decimalAllowed={false}
                                        placeholder="3"
                                        value={settingData?.security?.passkeys?.general_settings?.max_passkeys_number}
                                        handleChange={handleChange}
                                    />
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("Set the maximum number of passkeys a user can register (if enabled).", "ultimate-security")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Enabled User Roles", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint position="top" content={__("Choose Role", "ultimate-security")}/>                                    
                                    {
                                        rolesArray.length &&                                                                     
                                        <TagInput 
                                            name='security.passkeys.general_settings.included_user_roles'
                                            type='role' 
                                            whitelist={rolesArray}
                                            initialTags={settingData?.security?.passkeys?.general_settings?.included_user_roles} 
                                            handleChange={handleChange} 
                                        />
                                    }   
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("Select user roles to include from passkey registration and login.", "ultimate-security")}</p>
                                    <p className="pl-body text-text">{__("Users with the roles that isn't selected will not be able to log in, and the passkey registration form will not appear on the profile or registration shortcode.", "ultimate-security")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

             <div className="setting-unit pb-lg mb-lg border-bottom">
                <InfoBox className="big-infobox" title={__("NOTE", "ultimate-security")} content={__("Configure the WebAuthn and Passkeys login and registration options., we recommend using the default settings unless you have a good understanding of WebAuthn configuration.", "ultimate-security")} />
            </div>

            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Exclude Existing Credentials", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                           <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Enable Exclude Existing Credentials", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("Enable this option to prevent users from registering passkeys that are already registered (Recommended: enabled).", "ultimate-security")}</p>
                                </div>                            
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.passkeys.general_settings.exclude_existing_crdentials"
                                    checked={settingData?.security?.passkeys?.general_settings?.exclude_existing_crdentials}
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Registration Timeout", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="number-group d-flex align-items-center gap-2">
                                    <Hint position="top" content={__("Registration Timeout", "ultimate-security")}/>                                    
                                    <InputBox
                                        name="security.passkeys.general_settings.registration_timeout"
                                        type="number"
                                        min={1}
                                        max={5}
                                        decimalAllowed={false}
                                        placeholder="5"
                                        value={settingData?.security?.passkeys?.general_settings?.registration_timeout}
                                        handleChange={handleChange}
                                    />
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("Set the expiration timeout for passkey registration (in minutes).", "ultimate-security")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Login Timeout", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="number-group d-flex align-items-center gap-2">
                                    <Hint position="top" content={__("Login Timeout", "ultimate-security")}/>                                    
                                    <InputBox
                                        name="security.passkeys.general_settings.login_timeout"
                                        type="number"
                                        min={1}
                                        max={5}
                                        decimalAllowed={false}
                                        placeholder="5"
                                        value={settingData?.security?.passkeys?.general_settings?.login_timeout}
                                        handleChange={handleChange}
                                    />
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("Set the expiration timeout for passkey login (in minutes).", "ultimate-security")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Enable User Verifications", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                           <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Enable or disable the restriction for the maximum number of passkeys per user.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("Choose the level of user verification required during login (Recommended: enabled).", "ultimate-security")}</p>
                                </div>                            
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.passkeys.general_settings.enable_user_verification"
                                    checked={settingData?.security?.passkeys?.general_settings?.enable_user_verification} 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Login User Verification", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint position="top" content={__("Choose Login User Verification", "ultimate-security")}/>                                    
                                    <SingleSelect
                                        options={[
                                            {label: 'Required', value: 'required'},
                                            {label: 'Preferred', value: 'preferred'},
                                            {label: 'Discouraged', value: 'discouraged'},]}
                                        initialValue={settingData?.security?.passkeys?.general_settings?.login_user_verification || 'required'}
                                        name="security.passkeys.general_settings.login_user_verification"
                                        selected={settingData?.security?.passkeys?.general_settings?.login_user_verification}
                                        handleChange={handleChange}
                                    />
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("Choose the level of user verification required during passkey login.", "ultimate-security")}</p>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

        </>
    )
}
export default withForm(GeneralSettings,'security.passkeys.general_settings');